export const TAG_TYPES = {
    route_tag: 'Route Tag',
    accessorial_tag: 'Accessorial Tag',
    item_tag: 'Item Tag',
};
